/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RmaCreator } from './rmaCreator';


export interface AdminSearchRma { 
    rmaCreators?: Array<RmaCreator>;
    formattedRmaNumber?: string;
    deviceIds?: Array<number>;
    packageReceived?: boolean;
    assignedUser?: Array<number>;
    assignedSales?: Array<number>;
    rmaStatus?: Array<AdminSearchRma.RmaStatusEnum>;
    refurbishmentOrderIds?: Array<string>;
}
export namespace AdminSearchRma {
    export const RmaStatusEnum = {
        Created: 'Created',
        PackageReceivedInUs: 'PackageReceivedInUs',
        PackageSentFromUsToDe: 'PackageSentFromUsToDe',
        PackageReceivedInDe: 'PackageReceivedInDe',
        DeviceInspection: 'DeviceInspection',
        Quotation: 'Quotation',
        InConfiguration: 'InConfiguration',
        InRefurbishment: 'InRefurbishment',
        Completed: 'Completed'
    } as const;
    export type RmaStatusEnum = typeof RmaStatusEnum[keyof typeof RmaStatusEnum];
}


